// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"7dd287b9","212":"490eae5b","312":"84f45cf3","336":"01e33124","401":"0555a306","588":"7d9f6f45","650":"fc25eb54","652":"40011c35","893":"6f700c24","922":"d60e47b3","955":"ec71d25b","994":"935b9166"}[chunkId] + ".chunk.js";
};